module.exports = function(PluginManager) {
  PluginManager.registerVisitorProfileProvider(require('./providers/query_params'));
  PluginManager.registerAudienceMatcher('query', require('./matchers/query'));
};
